import type { ReactNode } from 'react';

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { cn } from '@/lib/utils';

export type CrudDrawerSize = 'md' | 'lg' | 'xl';

const SIZE_MAP: Record<CrudDrawerSize, string> = {
  md: 'sm:max-w-lg',
  lg: 'sm:max-w-xl',
  xl: 'sm:max-w-2xl',
};

export interface CrudDrawerProps {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  title: string;
  description?: string;
  size?: CrudDrawerSize;
  children: ReactNode;
  footer?: ReactNode;
}

export function CrudDrawer({
  open,
  onOpenChange,
  title,
  description,
  size = 'md',
  children,
  footer,
}: CrudDrawerProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className={cn('flex w-full flex-col gap-0 p-0', SIZE_MAP[size])}>
        <SheetHeader className="border-b border-(--color-border) p-6">
          <SheetTitle className="text-body-md text-accent-ink font-semibold">{title}</SheetTitle>
          {description ? (
            <SheetDescription className="text-meta-sm text-neutral-500">
              {description}
            </SheetDescription>
          ) : null}
        </SheetHeader>
        <div className="flex-1 overflow-y-auto p-6">{children}</div>
        {footer ? (
          <div className="border-t border-(--color-border) p-4">
            <div className="flex justify-end gap-2">{footer}</div>
          </div>
        ) : null}
      </SheetContent>
    </Sheet>
  );
}
